export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4608.5a6b0759.jpg";